<div class="exit-modal">
  <div class="exit-content">
    <div class="content-header">
      <div class="header-group">
        <h2>You’re about to leave without making a booking.</h2>
        <p>To improve your experience on this platform, we would love your feedback on why you did not make a booking today.</p>
      </div>
      <button class="arrow-btn" (click)="closeModal()"><img src="assets/images/close.svg" alt=""></button>
    </div>
    <div class="exit-options">
      <div *ngFor="let item of existOptions">
        <button (click)="selectReason(item)">{{ item }}</button>
      </div>
    </div> 
  </div>
</div>
